import Logo from "@/components/Logo";
import { useSectionNav } from "@/hooks/useSectionNav";
import { useLang } from "@/i18n";

const LINKS = [
    { id: "leistungen", de: "Leistungen", en: "Services", href: "#leistungen" },
    { id: "produkte", de: "Produkte", en: "Products", href: "/produkte" },
    { id: "download", de: "Download", en: "Downloads", href: "/downloads" },
    { id: "haendler-login", de: "Händler-Login", en: "Dealer Login", href: "#haendler" },
    { id: "kontakt", de: "Kontakt", en: "Contact", href: "#kontakt" },
    { id: "impressum", de: "Impressum", en: "Impressum", href: "/impressum" },
];

export default function Footer() {
    const go = useSectionNav();
    const { t } = useLang();
    return (
        <footer data-testid="footer" className="border-t border-slate-200 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
                <div className="grid md:grid-cols-3 gap-10">
                    <div>
                        <Logo big />
                        <p className="mt-4 text-sm text-slate-600 leading-relaxed max-w-xs">
                            {t(
                                "Ihr kompetenter Partner für Kabel- und SAT-Anlagen — Kopfstationen, Verteiltechnik und Reparaturservice aus Hemhofen.",
                                "Your competent partner for cable and satellite systems — headends, distribution technology and repair service from Hemhofen."
                            )}
                        </p>
                    </div>
                    <nav className="flex flex-col gap-2.5" aria-label="Footer Navigation">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                onClick={(e) => {
                                    e.preventDefault();
                                    go(l.href);
                                }}
                                data-testid={`footer-link-${l.id}`}
                                className="text-sm font-medium text-slate-600 hover:text-red-700 transition-colors w-fit"
                            >
                                {t(l.de, l.en)}
                            </a>
                        ))}
                    </nav>
                    <div className="text-sm text-slate-600 space-y-1.5" data-testid="footer-legal">
                        <p className="font-semibold text-slate-900">Müller Satelliten- und Antennentechnik GmbH</p>
                        <p>Barthelweiher 14 · 91334 Hemhofen · Germany</p>
                        <p>Tel. +49 (0) 9195 / 9404-0 · Fax +49 (0) 9195 / 9404-40</p>
                        <p>USt-IdNr. DE218585027 · St.Nr. 243 188 33562</p>
                    </div>
                </div>
                <div className="mt-10 border-t border-slate-200 pt-6 flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-widest text-slate-400">
                    <span>© {new Date().getFullYear()} Müller Satelliten- und Antennentechnik GmbH</span>
                    <span>{t("digital & analog · seit jeher am Empfang dran", "digital & analog · tuned in since day one")}</span>
                </div>
            </div>
        </footer>
    );
}
